import Breadcrumb from './views/components/Breadcrumb/Breadcrumb.vue';
import Modal from './components/Modal.vue';
import Pagination from './views/components/Pagination/Pagination.vue';
import TagsInput from 'vue3-tags-input';
import DatePicker from '@vuepic/vue-datepicker';
import MultiSelect from './views/components/MultiSelect/index.vue';
import Overlay from './views/components/Overlay/index.vue';
import FormatMask from './views/components/FormatMask/index.vue';
import Filter from './views/components/Filter/index.vue';
import Group from './views/components/Group/index.vue';
import Logo from './views/components/Logo/index.vue';
import DocMenu from './views/pages/docs/components/menu/index.vue';
import {GChart} from 'vue-google-charts';

export default (app) => {
  app.component('breadcrumb', Breadcrumb);
  app.component('b-modal', Modal);
  app.component('b-pagination', Pagination);
  app.component('tags-input', TagsInput);
  app.component('date-picker', DatePicker);
  app.component('multi-select', MultiSelect);
  app.component('overlay', Overlay);
  app.component('format-mask', FormatMask);
  app.component('filter-dropdown', Filter);
  app.component('group-dropdown', Group);
  app.component('doc-menu', DocMenu);
  app.component('logo', Logo);
  app.component('chart', GChart);
};
